export default __webpack_public_path__ + "locales/es/FilesSettings.json?hash=838950ab013d28bb680dc1768bebde10";